const getBaseUrl = () => process.env.REACT_APP_API_BASE_URL;
const getFlaskUrl = () => process.env.REACT_APP_FLASK_API_URL;

export const getUrl = (type) => {
  const baseUrl = getBaseUrl();
  const falskUrl = getFlaskUrl();
  switch (type) {
    case 'get-regassure-logs':
      return `${baseUrl}/regassure_logs/`;
    case 'user-login':
      return `${baseUrl}/login/`;
    case 'user-signup':
      return `${baseUrl}/regassure_registration`;
    case 'fetch-file':
      return `${baseUrl}/getfiles`;
    case 'fetch-ref-file':
      return `${baseUrl}/getreffiles`;
    case 'file-download':
      return `${baseUrl}/download`;
    case 'file-upload':
      return `${baseUrl}/upload/`;
    case 'analytics-accuracy':
      return `${baseUrl}/getanalytics`;
    case 'fetch-user':
      return `${baseUrl}/getusers`;
    case 'get-firm-spec':
      return `${baseUrl}/getfirmspec`;
    case 'get-products':
      return `${baseUrl}/getproducts`;
    case 'registration':
      return `${baseUrl}/registration/`;
    case 'forgot-password':
      return `${baseUrl}/forgot_password/`;
    case 'get-regulations':
      return `${baseUrl}/getreg`;
    case 'get-super-admin-firm':
      return `${baseUrl}/get_super_admin_firm`;
    case 'get-dashboard':
      return `${baseUrl}/dashboard`;
    case 'get-file-storage':
      return `${baseUrl}/getfilestorage`;
    case 'delete-file':
      return `${baseUrl}/delete_files`;
    case 'get-accuracy-analytics':
      return `${baseUrl}/get_accuracy_analytics`;
    case 'get-middleware-mifid-file-data':
      return `${baseUrl}/get_middleware_mifid_file_data`;
    case 'get-eno-analytics-file-data':
      return `${baseUrl}/get_eno_analytics_file_data`;
    case 'eno-analytics-dashboard':
      return `${baseUrl}/eno_analytics_dashboard`;
    case 'regassure-ref-data-to-DB':
      return `${baseUrl}/regassure_ref_data_to_DB`;
    case 'get-refdata-grid':
      return `${baseUrl}/get_refdata_grid`;
    case 'get-risk-calculator':
      return `${baseUrl}/getriskcalculator`;
    case 'eno-risk-calc-post-data':
      return `${baseUrl}/eno-risk-calc-post-data`;
    case 'get-completeness-grid':
      return `${baseUrl}/completeness_file_data_grid`;
    case 'get-middleware-emir-refit-grid':
      return `${baseUrl}/middleware_emir_refit_grid`;
    case 'get-flask-data':
      return `${falskUrl}/regassure-data`;
    case 'get-falsk-filter-values':
      return `${falskUrl}/regassure-filter-values`;
    case 'get-download-csv':
      return `${falskUrl}/regassure-download-csv`;
    case 'get-completeness-analytics':
      return `${baseUrl}/get_completeness_dashboard`;
    case 'get-middleware-analytics':
      return `${baseUrl}/get_middleware_dashboard`;
    case 'get-presigned-url':
      return `${baseUrl}/get_presigned_url`;
    case 'get-regassurelogin-url':
      return `${baseUrl}/regassure_login`;
    case 'get-regassurecompletnesss-grid-data-update':
      return `${baseUrl}/regassure_completeness_grid_data_update`;
    case 'post-regassure-accuracy-lifecycle':
      return `${baseUrl}/regassure_accuracy_lifecycle`;
    case 'post-regassure-eno-clearing-threshold':
      return `${baseUrl}/regassure_eno_clearing_threshold_post`;
    default:
      return baseUrl;
  }
};
